import clsx from 'clsx';
import React from 'react';
import Fade from 'react-reveal/Fade';

import NeonLine from '@/components/Primitive/NeonLine/NeonLine';

const NeonDot = ({ className }: { className?: string }) => {
  return (
    <div className={clsx('h-5 w-5 rounded-full bg-white', className)}>
      <div
        className={clsx(
          'absolute left-0 top-0 h-full w-full rounded-full bg-white blur-[3px]'
        )}
      />
      <div
        className={clsx(
          'absolute left-0 top-0 z-10 h-full w-full rounded-full shadow-[0px_1px_9px_5px] shadow-neonBlue-500'
        )}
      />
    </div>
  );
};

type TimelineItemProps = {
  id: string;
  title: string;
  description: string;
};

const TimelineItem = ({ title, description }: TimelineItemProps) => {
  return (
    <div className="relative pl-10 md:pl-24">
      <NeonDot className="absolute left-[-14px] top-2" />
      <div className="flex flex-col space-y-4">
        <h3 className="text-xl font-black uppercase text-cream sm:text-xl md:text-2xl">
          {title}
        </h3>
        <p className="text-lg font-medium text-grayAlt-500 sm:text-lg md:text-xl">
          {description}
        </p>
      </div>
    </div>
  );
};

export interface ITimelineProps {
  className?: string;
  items: TimelineItemProps[];
  padded?: boolean;
}

const Timeline = ({ className, items, padded = true }: ITimelineProps) => {
  return (
    <div className={clsx('relative flex py-4', className)}>
      <div className="flex flex-col">
        <NeonLine vertical />
      </div>

      <div
        className={clsx(
          'flex flex-col space-y-6 md:space-y-14',
          padded ? 'py-12 md:py-20' : 'py-2'
        )}
      >
        <Fade top>
          {items.map((item) => (
            <TimelineItem key={item.id} {...item} />
          ))}
        </Fade>
      </div>
    </div>
  );
};

export default Timeline;
